import React from 'react';
import classNames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { l_translation } from '@fiverr-private/fit/icons';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { baseTranslationButtonProps } from '../../../utils/props';
import withTranslationButtonWrapper from '../TranslationButtonWrapper';

import './style.scss';

const LeanToggledTranslationButton = ({
    toggled = false,
    loading = false,
    onClick = Function.prototype,
    i18n
}) => {
    const { locale } = getContext();

    const titleSuffix = !toggled || loading ? 'translate_to' : 'show_original';
    const language = i18n.t(`languages.${locale}`);

    return (
        <div className={classNames('lean-toggled-translation-button', { toggled })}>
            <div className="flex-center info-wrapper">
                {loading ?
                    <i className="loading-icon"/> :
                    <Icon className="translation-icon" size={22}>
                        {l_translation}
                    </Icon>
                }
                {toggled && (<i className="vendor-disclaimer"/>)}
            </div>
            <button onClick={onClick} disabled={loading}>
                <p className="text-body-2">
                    <I18n k={`machine_translation.${titleSuffix}`} params={{ language }}/>
                </p>
            </button>
        </div>
    );
};

LeanToggledTranslationButton.propTypes = baseTranslationButtonProps;

export default withTranslationButtonWrapper(LeanToggledTranslationButton);
